import { type RiskType } from "@/config";
import styles from "./RiskDetailsItem.module.sass";
import { getSignalTranslation } from "@/helpers";

interface RiskDetailsItemProps {
  label: string;
  type?: RiskType;
}

export const RiskDetailsItem = ({
  label,
}: RiskDetailsItemProps) => {
  const displayLabel = getSignalTranslation(label);

  return (
    <div className={styles.item}>
      <div className={styles.title}>{displayLabel}</div>
    </div>
  );
};
